<footer id="kv_footer" class="footer navbar-default">
    <div class="alert text-center cookieprompt" role="alert" [ngClass]="{display : !cookieClosed}">
        <p>This website uses cookies <span>{{ cookieEmoji }}</span> to ensure you get the best experience. 
         To find out more about cookies, please refer to our <a href="~/../app/misc/PTFS Cookie Policy.pdf" target="_blank"> Cookie Policy</a>.
         This policy also contains information on how to manage your cookies. Please note that if you continue to use our website, you accept the use of cookies.
        </p>
        <button type="button" class="btn btn-primary btn-sm" (click)="acceptCookies()">{{LOCALIZATION.privacyAccept}}</button>
        <button type="button" class="btn btn-primary btn-sm" (click)="manageCookies()">{{LOCALIZATION.privacy}}</button>
    </div>
    <div class="container-fluid text-center links-container">
    	<span class="footer-dynamic-copy footer-copy-text"></span>
        <span class="footer-link"><a href="http://www.ptfs.com/">{{LOCALIZATION.copyright}}</a></span>
        <span class="footer-link"><a href="#" (click)="about($event)">{{LOCALIZATION.about}}</a></span>
        <span class="footer-link"><a href="#" (click)="manageCookies($event)">{{LOCALIZATION.privacy}}</a></span>
    </div>
</footer>